import * as React from 'react';
import { Referral, ReferralCampaignsLoadStatus } from 'model/referralCampaign';
import { useAuth } from 'contexts/authUser/store';
import { authUserSelectors } from 'contexts/authUser';
import useApi from 'hooks/useApi';

const useUserReferralCampaigns = () => {
  const { api } = useApi();
  const [userReferralCampaigns, setUserReferralCampaigns] = React.useState<Referral[]>([]);
  const [loadStatus, setLoadStatus] = React.useState<ReferralCampaignsLoadStatus>(
    ReferralCampaignsLoadStatus.NOT_LOADED
  );
  const { isLoggedIn } = useAuth(state => ({
    isLoggedIn: authUserSelectors.isLoggedIn(state)
  }));

  const fetchUserReferralCampaigns = React.useCallback(async () => {
    if (isLoggedIn && api) {
      setLoadStatus(ReferralCampaignsLoadStatus.LOADING);
      const _userReferralCampaigns = await api.referral.referrals.getList({
        page: 0
      });
      // TODO remove any handle TS
      setUserReferralCampaigns((_userReferralCampaigns?.content as any) || []);
      setLoadStatus(ReferralCampaignsLoadStatus.LOADED);
    }
  }, [api, isLoggedIn]);

  React.useEffect(() => {
    fetchUserReferralCampaigns();
  }, [fetchUserReferralCampaigns]);

  const isLoading = React.useMemo(
    () => loadStatus === ReferralCampaignsLoadStatus.LOADING,
    [loadStatus]
  );

  const isLoaded = React.useMemo(
    () => loadStatus === ReferralCampaignsLoadStatus.LOADED,
    [loadStatus]
  );

  return { userReferralCampaigns, isLoading, isLoaded };
};

export default useUserReferralCampaigns;
